import { render, staticRenderFns } from "./ScreeningProcessActions.vue?vue&type=template&id=39326a93&scoped=true&"
import script from "./ScreeningProcessActions.vue?vue&type=script&lang=js&"
export * from "./ScreeningProcessActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39326a93",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
